import React, { useState, useEffect } from 'react';
import './StateWiseAlerts.css';
import Loader from '../Skleton/Loader';
import { url } from '../utils/baseurl';
export default function StateWiseAlerts() {
  const [stateData, setStateData] = useState([]);


  const [isloading, setisloading] = useState(false)

  async function getStateWiseAlerts() {
    setisloading(true);
  
    try {
      const response = await fetch(`${url}/FetchDashboardData`);
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      setStateData(data.statewise);
    } catch (error) {
      console.error('Error fetching state-wise data:', error);
      // You can handle the error here, e.g., show an error message to the user.
    }
  
    setisloading(false);
  }
  

  useEffect(() => {
    getStateWiseAlerts();
  }, []);

  return (<>



  {isloading?<>
  
  
  
  <Loader/>
  
  
  </>:<>
  


  {stateData.length>0?<>
  
  
  
    <div className="chart-box">
      <h1 className="text-2xl font-bold mb-4">State-wise Total Alerts</h1>
      <div className="table-container">
        <table className="chart-table">
          <thead>
            <tr>
              <th>State</th>
              <th>Red Alerts</th>
              <th>Orange Alerts</th>
              <th>Yellow Alerts</th>
              <th>Green Alerts</th>
            </tr>
          </thead>
          <tbody>
            {stateData.map((state) => (
              <tr key={state.state}>
                <td className="state">{state.state}</td>
                <td className="alert-count red">{state.alertStatistics.red_alerts}</td>
                <td className="alert-count orange">{state.alertStatistics.orange_alerts}</td>
                <td className="alert-count yellow">{state.alertStatistics.yellow_alerts}</td>
                <td className="alert-count green">{state.alertStatistics.green_alerts}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  
  
  </>:<>
  
  
  
  
  
<div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >

   <br />
   <br />
   <br />
   <br />
   <br />
   <br />

      <i>STATE WISE DATA NOT AVAILABLE RIGHT NOW PLEASE VISIT AFTER SOME TIME</i>
      </div>
      <br />


  
  
  
  
  
  </>}
 
  
  
  
  
  
  </>}

    </>
  );
}
